import { render } from "./ConfigOrganization.vue?vue&type=template&id=e9573a62"
import script from "./ConfigOrganization.vue?vue&type=script&lang=js"
export * from "./ConfigOrganization.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__